/* eslint-disable no-console */
let socket = null
let manualClose = false
let reconnectTimer = null
let reconnectAttempt = 0
let openingPromise = null
let resolvedWsUrl = ''

const JULIAM_COMPANY_KEY = 'juliam-arcade'
const JULIAM_WS_URL = 'wss://websockets.juliam.gestiontotal.app'

const listeners = new Set()

function fallbackWsUrl() {
  const host = window.location.hostname.toLowerCase()
  return host === 'localhost' || host === '127.0.0.1'
    ? 'ws://localhost:3097'
    : JULIAM_WS_URL
}

function scopedUrl(url) {
  const parsed = new URL(url)
  parsed.searchParams.set('company', JULIAM_COMPANY_KEY)
  return parsed.toString()
}

async function wsUrl() {
  if (resolvedWsUrl) return resolvedWsUrl

  try {
    const response = await fetch(`/api/menu/realtime?company=${JULIAM_COMPANY_KEY}`, {
      headers: { Accept: 'application/json', 'X-Company-Key': JULIAM_COMPANY_KEY },
      cache: 'no-store'
    })
    const data = response.ok ? await response.json() : null
    const dynamicUrl = String(data?.websocket_url || '').trim().replace(/\/$/, '')
    if (dynamicUrl) resolvedWsUrl = scopedUrl(dynamicUrl)
  } catch (_error) {
    // La derivacion local permite reconectar aunque el endpoint este reiniciando.
  }

  if (!resolvedWsUrl) resolvedWsUrl = scopedUrl(fallbackWsUrl())
  return resolvedWsUrl
}

function notify(payload) {
  listeners.forEach((listener) => {
    try { listener(payload) } catch (error) { console.warn('Realtime listener failed', error) }
  })
}

function scheduleReconnect() {
  if (manualClose || reconnectTimer) return
  const delay = Math.min(30000, 1000 * (2 ** Math.min(reconnectAttempt, 5))) + Math.round(Math.random() * 500)
  reconnectAttempt += 1
  reconnectTimer = setTimeout(() => {
    reconnectTimer = null
    openSocket()
  }, delay)
}

function openSocket() {
  if (manualClose || socket || openingPromise) return

  openingPromise = wsUrl()
    .then((url) => {
      if (manualClose || socket) return
      socket = new WebSocket(url)
      socket.onopen = () => {
        reconnectAttempt = 0
        socket.send(JSON.stringify({ event: 'subscribe', company_key: JULIAM_COMPANY_KEY }))
      }
      socket.onmessage = (event) => {
        try {
          const payload = JSON.parse(event.data)
          if (payload && payload.event && payload.event !== 'connected' && payload.company_key === JULIAM_COMPANY_KEY) notify(payload)
        } catch (error) {
          console.warn('Invalid realtime payload', error)
        }
      }
      socket.onclose = () => {
        socket = null
        scheduleReconnect()
      }
      socket.onerror = () => {
        try { socket.close() } catch (error) { /* noop */ }
      }
    })
    .catch(() => {
      socket = null
      scheduleReconnect()
    })
    .finally(() => { openingPromise = null })
}

export function connectMenuSocket(onMessage) {
  if (typeof onMessage === 'function') listeners.add(onMessage)
  manualClose = false
  openSocket()
  return () => listeners.delete(onMessage)
}

export function closeMenuSocket(onMessage) {
  if (typeof onMessage === 'function') listeners.delete(onMessage)
  if (listeners.size > 0) return

  manualClose = true
  clearTimeout(reconnectTimer)
  reconnectTimer = null
  if (socket) {
    try { socket.close() } catch (error) { /* noop */ }
  }
  socket = null
}
